import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormFeedback,
  Alert,
  Spinner,
} from "reactstrap";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser, socialLogin, resetLoginFlag } from "../../slices/thunks";

import logoLight from "../../assets/images/logo-light.png";
import { fetchBrandingConfig } from "../../slices/thunks";
import { createSelector } from "reselect";
import { useBrandingTitle } from "../../hooks";
import { CacheService } from "../../services/cache";
import { CacheConfig } from "../../services/cache/CacheConfig";
import { loadSystemConfigWithCache } from "../../helpers/systemConfigCache";
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('authentication');
//import images

const Login = (props: any) => {
  const dispatch: any = useDispatch();

  const selectLayoutState = (state: any) => state;
  const loginpageData = createSelector(selectLayoutState, (state) => ({
    user: state.Account.user,
    error: state.Login.error,
    errorMsg: state.Login.errorMsg,
    isAccountLocked: state.Login.isAccountLocked,
  }));
  // Inside your component
  const { user, error, errorMsg, isAccountLocked } = useSelector(loginpageData);

  const selectBrandingState = (state: any) => state.BrandingConfiguration;
  const brandingData = createSelector(selectBrandingState, (state) => ({
    config: state.config,
    loading: state.loading,
  }));
  const { config: brandingConfig } = useSelector(brandingData);

  const [userLogin, setUserLogin] = useState<any>([]);
  const [passwordShow, setPasswordShow] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const [renderComplete, setRenderComplete] = useState<boolean>(false);

  /**
   * Effect: Load branding config với cache support
   * - Check cache trước
   * - Nếu có cache, dùng cached data
   * - Nếu không có, fetch từ API và cache lại
   */
  useEffect(() => {
    const loadBrandingConfig = async () => {
      const cacheKey = CacheConfig.BRANDING.key;
      const cacheTtl = CacheConfig.BRANDING.ttl;

      // Check cache trước
      const cached = CacheService.get(cacheKey);

      if (cached.cached && cached.data) {
        console.log("[Login] Using cached branding config", cached.data);
        // Redux state đã có data từ cache hoặc previous load
        // Không cần dispatch nếu brandingConfig đã có
      } else {
        console.log("[Login] Fetching branding config from API");
        // Fetch từ API
        const result = await dispatch(fetchBrandingConfig());

        // Lưu vào cache nếu fetch thành công
        if (result.payload) {
          CacheService.set(cacheKey, result.payload, cacheTtl);
          console.log("[Login] Branding config cached");
        }
      }
    };

    loadBrandingConfig();
  }, [dispatch]);

  useEffect(() => {
    // if (user && user) {
    //     const updatedUserData = process.env.REACT_APP_DEFAULTAUTH === "firebase" ? user.multiFactor.user.userName : user.userName;
    //     const updatedUserPassword = process.env.REACT_APP_DEFAULTAUTH === "firebase" ? "" : user.confirm_password;
    //     const updatedTenant = user.tenant || '';
    //     setUserLogin({
    //         userName: updatedUserData,
    //         password: updatedUserPassword,
    //         tenant: updatedTenant
    //     });
    // }
  }, [user]);

  /**
   * Effect: Sau khi đăng nhập thành công, nạp SystemConfig vào cache (lms_cache_system_config)
   * — ưu tiên đọc cache, cache miss mới gọi SystemService/GetSystemConfig
   */
  useEffect(() => {
    if (user) {
      loadSystemConfigWithCache(dispatch);
    }
  }, [user, dispatch]);

  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      userName: userLogin.userName || "",
      password: userLogin.password || "",
      tenant: "BGD", // Tự động fill tenant mặc định
    },
    validationSchema: Yup.object({
      userName: Yup.string().required(st('vui_long_nhap_ten_dang_nhap_error')),
      password: Yup.string().required(st('vui_long_nhap_mat_khau_error')),
      // tenant validation bỏ qua vì đã tự động fill
    }),
    onSubmit: (values) => {
      // Lấy lại trang trước đó (nếu bị redirect từ AuthProtected khi truy cập
      // trang chưa đăng nhập) để sau khi đăng nhập xong quay lại đúng trang đó
      const from = props.router.location?.state?.from;
      const returnUrl = from
        ? `${from.pathname || ""}${from.search || ""}`
        : undefined;
      dispatch(loginUser(values, props.router.navigate, returnUrl));
      setLoader(true);
    },
  });

  const signIn = (type: any) => {
    const from = props.router.location?.state?.from;
    const returnUrl = from
      ? `${from.pathname || ""}${from.search || ""}`
      : undefined;
    dispatch(socialLogin(type, props.router.navigate, returnUrl));
  };

  //for facebook and google authentication
  const socialResponse = (type: any) => {
    signIn(type);
  };

  /**
   * Effect: Đánh dấu render complete sau khi UI render xong
   * Đợi một frame để đảm bảo UI đã hiển thị
   */
  useEffect(() => {
    const timer = setTimeout(() => {
      setRenderComplete(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  /**
   * Effect: Background refresh branding config sau khi render complete
   * Chỉ chạy nếu config cho phép refreshAfterRender
   */
  useEffect(() => {
    if (renderComplete && CacheConfig.BRANDING.refreshAfterRender) {
      const cacheKey = CacheConfig.BRANDING.key;
      const cacheTtl = CacheConfig.BRANDING.ttl;

      console.log("[Login] Scheduling background refresh for branding config");

      // Refresh trong background, không block UI
      CacheService.refreshInBackground(
        cacheKey,
        async () => {
          const result = await dispatch(fetchBrandingConfig());
          return result.payload;
        },
        cacheTtl,
      );
    }
  }, [renderComplete, dispatch]);

  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetLoginFlag());
        setLoader(false);
      }, 3000);
    }
  }, [dispatch, errorMsg]);

  useBrandingTitle(st('dang_nhap_text'));
  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content mt-lg-5">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 mb-4 text-white-50">
                  <div>
                    <Link to="/" className="d-inline-block auth-logo">
                      <img
                        src={brandingConfig?.logoUrl || logoLight}
                        alt={st('logo_alt')}
                        height="50"
                      />
                    </Link>
                  </div>
                  <p className="mt-3 fs-15 fw-medium">
                    {brandingConfig?.companyName || st('he_thong_quan_ly_xo_so_text')}
                  </p>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-4">
                  <CardBody className="p-4">
                    <div className="text-center mt-2">
                      <h5 className="text-primary">{st('chao_mung_tro_lai_title')}</h5>
                      <p className="text-muted">
                        {st('dang_nhap_de_tiep_tuc_su_text')}
                      </p>
                    </div>
                    {error && error && !isAccountLocked ? (
                      <Alert color="danger"> {error} </Alert>
                    ) : null}
                    <div className="p-2 mt-4">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                        action="#"
                      >
                        <div className="mb-3">
                          <Label htmlFor="userName" className="form-label">
                            {st('ten_dang_nhap_label')}
                          </Label>
                          <Input
                            name="userName"
                            className="form-control"
                            placeholder={st('nhap_ten_dang_nhap_placeholder')}
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.userName || ""}
                            invalid={
                              validation.touched.userName &&
                              validation.errors.userName
                                ? true
                                : false
                            }
                          />
                          {validation.touched.userName &&
                          validation.errors.userName ? (
                            <FormFeedback type="invalid">
                              {validation.errors.userName}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <div className="float-end">
                            <Link to="/forgot-password" className="text-muted">
                              {st('quen_mat_khau_title')}
                            </Link>
                          </div>
                          <Label
                            className="form-label"
                            htmlFor="password-input"
                          >
                            {st('mat_khau_label')}
                          </Label>
                          <div className="position-relative auth-pass-inputgroup mb-3">
                            <Input
                              name="password"
                              value={validation.values.password || ""}
                              type={passwordShow ? "text" : "password"}
                              className="form-control pe-5"
                              placeholder={st('nhap_mat_khau_placeholder')}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.password &&
                                validation.errors.password
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.password &&
                            validation.errors.password ? (
                              <FormFeedback type="invalid">
                                {validation.errors.password}
                              </FormFeedback>
                            ) : null}
                            <button
                              className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                              type="button"
                              id="password-addon"
                              onClick={() => setPasswordShow(!passwordShow)}
                            >
                              <i className="ri-eye-fill align-middle"></i>
                            </button>
                          </div>
                        </div>

                        {/* TENANT FIELD - ẨN ĐI, tự động fill 'BGD' */}
                        {/* Tính năng này sẽ được phát triển mở rộng trong tương lai */}
                        <Input
                          name="tenant"
                          type="hidden"
                          value={validation.values.tenant}
                        />

                        <div className="form-check">
                          <Input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="auth-remember-check"
                          />
                          <Label
                            className="form-check-label"
                            htmlFor="auth-remember-check"
                          >
                            {st('ghi_nho_dang_nhap_label')}
                          </Label>
                        </div>

                        <div className="mt-4">
                          <Button
                            color="success"
                            disabled={loader && true}
                            className="btn btn-success w-100"
                            type="submit"
                          >
                            {loader && (
                              <Spinner size="sm" className="me-2">
                                {" "}
                                {st('loading_text')}{" "}
                              </Spinner>
                            )}
                            {st('dang_nhap_text')}
                          </Button>
                          {isAccountLocked && (
                            <div className="text-center mt-2">
                              <span className="fst-italic fw-bold text-danger">
                                {st('tai_khoan_cua_ban_da_bi_text')}
                              </span>
                            </div>
                          )}
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default withRouter(Login);
